import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Loader from "./Loader";
import Maintenance from "./Maintainance";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
